import templateMarkup from 'raw-loader!./developer-portal-view.html';

function DeveloperPortalView(day, callId) {
    var self = this;
    self.initialize(day,  callId);
}

DeveloperPortalView.prototype = {
    initialize: function (params) {
        var self = this;
        self.dataProvider = params.dataProvider;
        self.params = params;
        self.route = params.route;

    },

    dispose: function () {
    }
};

export default { template: templateMarkup, viewModel: DeveloperPortalView };
